import { BaseService } from "./base.service";
import { Http } from "./http.init";
import { assert } from "@/core";
export class UniversityService extends BaseService {
  constructor() {
    super("universities");
  }

  async create(payload = {}) {
    assert.object(payload, { required: true });
    const response = await new Http({
      auth: true,
      headers: { "Content-Type": "multipart/form-data" }
    }).post(`${this.entity}`, payload);
    return response.data;
  }

  async update(id, payload = {}) {
    assert.object(payload, { required: true });
    const response = await new Http({
      auth: true,
      headers: { "Content-Type": "multipart/form-data" }
    }).post(`${this.entity}/${id}`, payload);
    return response.data;
  }

  async getRatetingByUniId(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({ auth: true }).get(
      `${this.entity}/${id}/ratings`,
      {}
    );
    return response.data;
  }

  async updateUniversityRatingSummaries(id = window.required(), data = {}) {
    assert.id(id, { required: true });
    assert.object(data, { required: true });

    const response = await this.request({ auth: true }).post(
      `${this.entity}/${id}/rating-summary`,
      data
    );
    return response.data;
  }

  async getUniversityRatingSummaries(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({ auth: true }).get(
      `${this.entity}/${id}/rating-summary`
    );
    return response.data;
  }

  async updateUniRatingCriteria(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({ auth: true }).post(
      `${this.entity}/${id}/update-rating-criteria`,
      {}
    );
    return response.data;
  }

  async exportExcelRating(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({
      auth: true,
      responseType: "blob"
    }).get(`${this.entity}/${id}/ratings/export/excel`);
    if (!response) return;
    let url = (window.URL || window.webkitURL).createObjectURL(
      new Blob([response.data])
    );
    let link = document.createElement("a");
    link.href = url;
    link.download = "UniversityRatingExport.xlsx";
    link.click();
    link.remove();
  }
}
